/* global tf, Worker, k, Image */

import { GetExifThumbnail } from '../../modules/GetExifThumbnail.js';

export class ImageClassifier {
  constructor(modelName, size) {
    this.loadModel(modelName);
    this._modelName = modelName;
    this._size = size;
    this._queue = [];
    this._workers = [];
    this._labels = [
      'back',
      'birthmark',
      'cabletag',
      'grounded',
      'groundline circumference',
      'hallway',
      'midspanheight',
      'osmose',
      'poleheight',
      'side',
      'sync',
      'tag',
      'tag osmose',
      'upshot'
    ];
  }

  loadModel(modelName) {
    this.modelUrl = `https://storage.googleapis.com/katapult-pro-shared-files/ai/${modelName}/tensorflowjs_model.pb`;
    this.weightsUrl = `https://storage.googleapis.com/katapult-pro-shared-files/ai/${modelName}/weights_manifest.json`;
    this._model = tf.loadFrozenModel(this.modelUrl, this.weightsUrl);
  }

  fromFiles(files, callback) {
    return Promise.resolve(this.labelPhotos(Array.from(files), (file) => Promise.resolve(GetExifThumbnail(file)), callback));
  }

  labelPhoto(dataUrl) {
    return new Promise((resolve, reject) => {
      let image = new Image();
      image.onload = () => {
        let tensor = null;
        try {
          let temp = tf.fromPixels(image);
          tensor = tf.image
            .resizeNearestNeighbor(temp, [this._size, this._size])
            .expandDims(0)
            .toFloat()
            .div(tf.scalar(127))
            .sub(tf.scalar(1));
          temp.dispose();
        } catch (e) {
          reject(e);
        }
        Promise.resolve(this._model).then((model) => {
          try {
            model
              .predict(tensor)
              .data()
              .then((confidences) => {
                let results = [];
                Array.from(confidences).forEach((confidence, i) => {
                  let label = this._labels[i];
                  results.push({ confidence, label });
                });
                results.sort((a, b) => b.confidence - a.confidence).slice(0, 1);
                tensor.dispose();
                resolve(results);
              });
          } catch (e) {
            reject(e);
          }
        });
      };
      image.onerror = (err) => {
        console.warn(dataUrl);
        reject(err);
      };
      image.src = dataUrl;
    });
  }

  labelPhotos(items, getImage, callback, finalCallback) {
    return new Promise((resolve, reject) => {
      // If already running, reject.
      if (this.busy) reject(new Error('Busy'));
      else {
        // Save reference to individual callback.
        this._callback = callback;
        // Populate the queue with items to process.
        this._queue = items.map((x) => x);
        // Reset labels array.
        this._predictions = [];
        // Assign function for converting files to dataURLs.
        this.getImage = getImage;
        // Set busy flag.
        this.busy = true;
        let cycle = (item) => {
          let results = { item };
          this.getImage(item)
            .then((dataUrl) => {
              if (dataUrl) results.thumbnail = dataUrl;
              this.labelPhoto(dataUrl)
                .then((labels) => {
                  results.labels = labels;
                  if (callback) callback(null, results);
                })
                .catch((e) => {
                  e.item = item;
                  if (callback) callback(e, results);
                })
                .finally(() => {
                  if (this._queue.length) cycle(this._queue.shift());
                  else {
                    this.busy = false;
                    resolve();
                  }
                });
            })
            .catch((e) => {
              e.item = item;
              if (callback) callback(e);
            });
        };
        cycle(this._queue.shift());
      }
    });
  }
}
